// Promotion status → antd Tag colour (spec: promotions), consistent with the duty-assistant
// status-colour convention.
import React from 'react'
import { Tag } from 'antd'

// Derive a promotion's display status from its active flag + date window (mirrors the API is_live).
export const promotionStatus = promo => {
  if (!promo) return { label: 'unknown', color: 'default' }
  if (!promo.isActive) return { label: 'Off', color: 'default' }
  const now = Date.now()
  const start = promo.startAt ? new Date(promo.startAt).getTime() : null
  const end = promo.endAt ? new Date(promo.endAt).getTime() : null
  if (start && now < start) return { label: 'Scheduled', color: 'geekblue' }
  if (end && now > end) return { label: 'Ended', color: 'default' }
  return { label: 'Live', color: 'green' }
}

export const promotionStatusTag = promo => {
  const { label, color } = promotionStatus(promo)
  return (
    <Tag color={color} style={{ marginBottom: 0 }}>
      {label}
    </Tag>
  )
}
